__webpack_require__.p = "/gpt/";